import { createReactiveContext } from '../../../../../../helpers/reactiveContext';

const {
  useMethods: useStateControllers,
  useSelector: useStateSelector,
  Provider: StateProvider,
} = createReactiveContext();

export { StateProvider, useStateSelector, useStateControllers };
